export default __webpack_public_path__ + "static/Data-Normal-1df64de92ea79d98a6a25d2f2223206b.svg";